import { render, staticRenderFns } from "./ViewBill old.vue?vue&type=template&id=554e512a&scoped=true&"
import script from "./ViewBill old.vue?vue&type=script&lang=js&"
export * from "./ViewBill old.vue?vue&type=script&lang=js&"
import style0 from "./ViewBill old.vue?vue&type=style&index=0&id=554e512a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554e512a",
  null
  
)

export default component.exports